import { cloneDeep } from 'lodash';
import { ChangeReviewConfig } from './change-review.model';
import { diffChanges } from './change-review.utils';

// the saved values an edit page compares against; moves forward on every confirmed save
export class UnsavedChangesTracker<T> {
  hasUnsavedChanges = false;

  private snapshot?: T;
  private submitted?: T;

  constructor(
    private readonly current: () => T,
    private readonly config: (baseline: T) => ChangeReviewConfig,
  ) {}

  get baseline(): T | undefined {
    return this.snapshot;
  }

  // once the form shows the loaded values
  start(): void {
    this.snapshot = this.current();
    this.refresh();
  }

  // for parts of the page that finish loading after start()
  absorb(keys: string[]): void {
    if (!this.snapshot) return;
    const current = this.current() as Record<string, unknown>;
    const snapshot = this.snapshot as Record<string, unknown>;
    keys.forEach((key) => (snapshot[key] = cloneDeep(current[key])));
    this.refresh();
  }

  // false until start(), so create pages never block
  refresh(): boolean {
    this.hasUnsavedChanges =
      !!this.snapshot && diffChanges(this.snapshot, this.current(), this.config(this.snapshot)).length > 0;
    return this.hasUnsavedChanges;
  }

  submit(payload: T): void {
    this.submitted = payload;
  }

  // on save success: the page stays and the next review compares against this save
  markSaved(): boolean {
    if (!this.submitted) return false;
    this.snapshot = this.submitted;
    this.submitted = undefined;
    this.refresh();
    return true;
  }
}
